import { NavigationMenuLink } from '@/atoms/components/ui/navigation-menu'
import { MenuShell } from './DesktopNav'
import Link from 'next/link'
import { ArrowRight } from 'lucide-react'
import Image from 'next/image'

export const MarketplaceMenu = () => {
  return (
    <MenuShell>
      <div className="grid gap-6 lg:grid-cols-[1.5fr_1fr_1fr]">
        <NavigationMenuLink asChild>
          <Link
            href="/product/talent-marketplace/"
            className="rounded-2xl border border-[#4242B6] flex flex-col justify-between bg-[#060135]"
          >
            <div className="flex flex-col gap-4 p-6">
              <div className="flex items-center justify-between">
                <p className="text-lg font-semibold text-slate-900">
                  On-demand Experts for high-quality content
                </p>
                <ArrowRight className="h-4 w-4 text-slate-500" />
              </div>
              <p className="text-sm text-slate-600">
                Access world-class content specialists on demand.
                Expert-crafted, brand-ready content delivered at speed across
                every industry and format.
              </p>
            </div>
            <Image
              alt=""
              src="/assets/inc/nav/talent-on-demand.png"
              width={1200}
              height={584}
            />
          </Link>
        </NavigationMenuLink>

        <div className="grid gap-4">
          <NavigationMenuLink asChild>
            <Link
              href="/blog/editorial-excellence-how-we-find-the-best-writers-on-our-platform/"
              className="rounded-2xl border border-[#4242B6] p-4 flex flex-col gap-3 bg-[#060135] overflow-hidden"
            >
              <div className="flex items-center justify-between">
                <p className="text-base font-semibold text-slate-900">
                  Top 3% Talent
                </p>
                <ArrowRight className="h-4 w-4 text-slate-500" />
              </div>
              <p
                className="text-sm text-slate-600
                  relative
         after:content-['TALENT']
         after:text-[80px]
         after:font-black
         after:leading-[0.8]
         after:tracking-[-4px]
         after:uppercase
         after:opacity-30
         after:bg-[linear-gradient(180deg,var(--Colors-Grey-Border,#4242B6)_-90.62%,#1D1D50_81.25%)]
         after:bg-clip-text after:text-transparent
         after:absolute
         after:top-24
         after:left-5
                  "
              >
                Hire only the best. Our rigorous vetting ensures you work with
                the top 3% of global creative and marketing talent.
              </p>
            </Link>
          </NavigationMenuLink>
          <NavigationMenuLink asChild>
            <Link
              href="/product/creator/"
              className="rounded-2xl border border-[#4242B6] p-4 flex flex-col gap-3 bg-[#060135] overflow-hidden"
            >
              <div className="flex items-center justify-between">
                <p className="text-base font-semibold text-slate-900">
                  Apply as a Creator
                </p>
                <ArrowRight className="h-4 w-4 text-slate-500" />
              </div>
              <p
                className="text-sm text-slate-600
                  relative
         after:content-['CREATOR']
         after:text-[80px]
         after:font-black
         after:leading-[0.8]
         after:tracking-[-4px]
         after:uppercase
         after:opacity-30
         after:bg-[linear-gradient(180deg,var(--Colors-Grey-Border,#4242B6)_-90.62%,#1D1D50_81.25%)]
         after:bg-clip-text after:text-transparent
         after:absolute
         after:top-28
                  "
              >
                Join Pepper&apos;s elite creator network. Work with leading
                global brands and create at the cutting edge of AI-assisted
                tools and platforms.
              </p>
            </Link>
          </NavigationMenuLink>
        </div>
        <div className="rounded-2xl border border-[#4242B6] bg-[#060135]">
          <Image
            alt=""
            src="/assets/inc/nav/top3-talent.png"
            width={1200}
            height={584}
          />
        </div>
      </div>
    </MenuShell>
  )
}
